/*
  JS del buscador del header (snippets/search-expanded.liquid). Antes iba inline
  en cada pagina (38 KB). Las URLs de assets que usa vienen de
  window.sensiboHeaderAssets, que define sections/header.liquid.
*/
    // Global variables
    window.searchTrigger = null;
    window.searchExpanded = null;
    window.searchInput = null;
    window.closeButton = null;
    window.searchOverlay = null;
    window.resultsContainer = null;
    window.blogResultsContainer = null;
    window.recommendedProductsContainer = null;
    window.currentPage = 1;
    window.articlesPerPage = 3;

    document.addEventListener('DOMContentLoaded', function () {
        // Initialize global variables
        window.searchTrigger = document.querySelector('.search-trigger');
        window.searchExpanded = document.querySelector('.search-expanded');
        window.searchInput = document.querySelector('.search-expanded .search__input');
        window.closeButton = document.querySelector('.close-search');
        window.searchOverlay = document.querySelector('.search-overlay');
        window.resultsContainer = document.querySelector('#predictive-search-results');
        window.blogResultsContainer = document.getElementById('blog-search-results');
        window.recommendedProductsContainer = document.getElementById('recommended-products');

        const productCategories = {
            acControl: {
                priority: 1,
                keywords: ['air conditioner', 'ac control', 'smart ac', 'remote ac', 'remote control', 'wifi control',
                    'heat pump', 'heat pump controller', 'heat pump smart control', 'controller', 'phone',
                    'climate control', 'hvac', 'smart thermostat', 'application', 'app', 'temperature', 'humidity'],
                products: [{
                    name: 'Sensibo Air Pro',
                    url: '/products/sensibo-air-pro'
                }]
            },
            airQuality: {
                priority: 2,
                keywords: ['air quality', 'iaq', 'co₂', 'indoor air quality', 'voc', 'pm2.5', 'pm10',
                    'air pollution', 'humidity sensor', 'tvoc', 'air monitoring', 'air measurement', 'smart air quality'],
                products: [{
                    name: 'Sensibo Elements',
                    url: '/products/sensibo-elements'
                }]
            },
            airPurification: {
                priority: 2,
                keywords: ['air purifier', 'hepa', 'air filtration', 'clean air', 'filter',
                    'dust', 'pollen', 'allergens', 'pet dander', 'improve air quality', 'air sanitizer'],
                products: [
                    {
                        name: 'Sensibo Pure',
                        url: '/products/sensibo-pure'
                    },
                    {
                        name: 'Sensibo Pure Filters',
                        url: '/products/sensibo-pure-filter'
                    }
                ]
            },
            smartSensors: {
                priority: 3,
                keywords: ['smart sensor', 'motion sensor', 'temperature sensor', 'door sensor', 'window sensor',
                    'open/close sensor', 'occupancy sensor', 'presence detection', 'humidity sensor'],
                products: [
                    {
                        name: 'Sensibo Smart Door/Window Sensor',
                        url: '/products/door-sensor'
                    },
                    {
                        name: 'Sensibo Room Sensor',
                        url: '/products/room-sensor'
                    }
                ]
            },
            hotels: {
                priority: 4,
                keywords: ['hotel', 'hospitality', 'guest experience', 'room automation',
                    'energy management hotel', 'hotel smart control', 'hvac hotel', 'air conditioning hotel'],
                product: {
                    name: 'Sensibo Airbend for Hotels',
                    url: '/pages/airbend-hotels'
                }
            },
            education: {
                priority: 4,
                keywords: ['school', 'classroom air quality', 'educational facilities',
                    'student air quality', 'energy savings schools', 'smart hvac schools', 'classroom climate control'],
                product: {
                    name: 'Sensibo Airbend for Schools',
                    url: '/pages/airbend-schools'
                }
            },
            commercialBuildings: {
                priority: 4,
                keywords: ['office', 'workspace', 'commercial building', 'facility management',
                    'smart hvac system', 'building automation', 'energy efficiency',
                    'enterprise hvac', 'business climate control'],
                products: [
                    {
                        name: 'Sensibo Airbend',
                        url: '/pages/airbend'
                    },
                    {
                        name: 'Sensibo for Integrators',
                        url: '/pages/sensibo-for-integrators-and-facility-management'
                    }
                ]
            },
            manufacturers: {
                priority: 5,
                keywords: ['oem', 'white label', 'manufacturer', 'b2b solutions',
                    'os', 'embedded software', 'hvac software', 'firmware',
                    'api integration', 'iot hvac', 'custom hvac solution'],
                product: {
                    name: 'Sensibo OS',
                    url: '/pages/sensibo-os-for-brands'
                }
            },
            children: {
                priority: 3,
                keywords: ['baby', 'toddler', 'newborn', 'infant', 'kids', 'children',
                    'nursery', 'baby room', 'asthma', 'allergies',
                    'child', 'safe air', 'protect baby'],
                product: {
                    name: 'Sensibo Healthy Children Bundle',
                    url: '/products/new-born-bundle'
                }
            },
            airbnb: {
                priority: 4,
                keywords: ['airbnb', 'short-term rental', 'vacation rental', 'guest control',
                    'host', 'property manager', 'smart hosting', 'smart thermostat rental',
                    'rental automation', 'energy savings airbnb', 'airbnb smart home'],
                product: {
                    name: 'Sensibo for Airbnb Hosts',
                    url: '/products/airbnb-for-hosts'
                }
            },
            sustainability: {
                priority: 3,
                keywords: ['sustainability', 'carbon footprint', 'co₂ emissions', 'energy efficiency',
                    'carbon reduction', 'net zero', 'climate impact', 'esg',
                    'decarbonization', 'co₂ monitoring', 'energy savings', 'green tech',
                    'eco-friendly', 'sustainable living', 'climate change mitigation',
                    'carbon offset', 'green innovation', 'smart energy'],
                product: {
                    name: 'Sensibo Impact',
                    url: '/pages/our-impact'
                }
            }
        };

        const resultSlots = {
            1: document.getElementById('result-1'),
            2: document.getElementById('result-2'),
            3: document.getElementById('result-3'),
            4: document.getElementById('result-4'),
            5: document.getElementById('result-5'),
            6: document.getElementById('result-6'),
            7: document.getElementById('result-7'),
            8: document.getElementById('result-8'),
            9: document.getElementById('result-9'),
            10: document.getElementById('result-10'),
            11: document.getElementById('result-11'),
            12: document.getElementById('result-12'),
            13: document.getElementById('result-13'),
            14: document.getElementById('result-14'),
            15: document.getElementById('result-15')
        };

        const fourPointFiveStarProducts = [
            'sensibo-elements',
            'sensibo-children-bundle',
            'sensibo-pure'
        ];

        // Event listeners from first script
        function closeMenuDrawerIfOpen() {
            var details = document.getElementById('details-menu-drawer-container');
            if (details && details.hasAttribute('open')) {
                // Prevent closeMenuDrawer from also closing search
                window.__skipSearchClose = true;
                var headerDrawer = details.closest('header-drawer');
                if (headerDrawer) {
                    var summary = details.querySelector('summary');
                    headerDrawer.closeMenuDrawer(new Event('click'), summary);
                }
                window.__skipSearchClose = false;
            }
            // Reset hamburger icon
            var menuToggle = document.getElementById('menu-toggle');
            if (menuToggle) menuToggle.classList.remove('active');
        }

        // Los dos cierres de abajo se programan con setTimeout para dejar correr
        // la transicion de opacidad antes de sacar el elemento del flujo. Si no
        // se cancelan, ese cierre diferido cae encima de una apertura posterior
        // y apaga algo que el usuario acaba de abrir. Hay que guardarlos.
        let hideAllTimeout;      // el de closeSearch: tapa campo + panel
        let hideOverlayTimeout;  // el de query corto: tapa solo el panel

        function openSearch() {
            clearTimeout(hideAllTimeout);
            closeMenuDrawerIfOpen();
            searchExpanded.style.display = 'block';
            requestAnimationFrame(function () {
                searchExpanded.classList.add('is-visible');
            });
            searchInput.focus();
        }

        function closeSearch() {
            searchExpanded.classList.remove('is-visible');
            searchOverlay.classList.remove('is-visible');
            clearTimeout(hideAllTimeout);
            hideAllTimeout = setTimeout(function () {
                searchExpanded.style.display = 'none';
                searchOverlay.style.display = 'none';
            }, 200);
            searchInput.value = '';
        }

        // Expose closeSearch globally so menu drawer can call it
        window.__closeSearch = closeSearch;

        searchTrigger.addEventListener('click', openSearch);
        closeButton.addEventListener('click', closeSearch);

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closeSearch();
        });

        function showLoaders() {
            resultsContainer.innerHTML = `
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;

            Object.values(resultSlots).forEach(slot => {
                slot.innerHTML = '';
            });
        }

        async function performSearch(query) {
            if (query.length <= 2) {
                searchOverlay.classList.remove('is-visible');
                setTimeout(function () { searchOverlay.style.display = 'none'; }, 200);
                resultsContainer.innerHTML = '';
                Object.values(resultSlots).forEach(slot => slot.innerHTML = '');
                return;
            }

            try {
                showLoaders();

                const searchQuery = query.toLowerCase() === 'smart ac' ? 'smart a' : query;

                const [articleResponse, productResponse] = await Promise.all([
                    fetch(`https://lxkirhznet6fjpzyjd23ofrixq0ghqsv.lambda-url.eu-west-1.on.aws/?q=${encodeURIComponent(searchQuery)}`),
                    fetch(`/search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[limit]=20&resources[options][fields]=title,body,product_type,tag,variants.title,vendor&resources[limit_scope]=each`)
                ]);

                const [articleData, productData] = await Promise.all([
                    articleResponse.json(),
                    productResponse.json()
                ]);

                document.querySelectorAll('.loading-overlay__spinner').forEach(spinner => {
                    spinner.style.display = 'none';
                });

                const shopifyProducts = productData.resources?.results?.products || [];
                const shopifyProductTitles = shopifyProducts.map(product => product.title.toLowerCase());

                let matches = [];
                let categoryMatches = new Map();

                Object.entries(productCategories).forEach(([categoryKey, category]) => {
                    let categoryScore = 0;
                    let matchedKeywords = new Set();

                    category.keywords.forEach(keyword => {
                        if (keyword.toLowerCase().includes(query) || query.includes(keyword.toLowerCase())) {
                            matchedKeywords.add(keyword);
                            categoryScore += 1;
                        }
                    });

                    if (categoryScore > 0) {
                        categoryMatches.set(categoryKey, {
                            score: categoryScore * (1 / category.priority),
                            matchCount: matchedKeywords.size
                        });

                        if (category.products) {
                            category.products.forEach(product => {
                                matches.push({
                                    name: product.name,
                                    url: product.url,
                                    score: categoryScore * (1 / category.priority),
                                    categoryKey: categoryKey
                                });
                            });
                        } else if (category.product && !shopifyProductTitles.includes(category.product.name.toLowerCase())) {
                            matches.push({
                                name: category.product.name,
                                url: category.product.url,
                                score: categoryScore * (1 / category.priority),
                                categoryKey: categoryKey
                            });
                        }
                    }
                });

                matches.sort((a, b) => {
                    if (b.score !== a.score) {
                        return b.score - a.score;
                    }
                    const categoryA = productCategories[a.categoryKey];
                    const categoryB = productCategories[b.categoryKey];
                    return categoryA.priority - categoryB.priority;
                });

                const seen = new Set();
                const uniqueMatches = matches.filter(item => {
                    const duplicate = seen.has(item.name);
                    seen.add(item.name);
                    return !duplicate;
                });

                const filteredDefaultSuggestions = defaultSuggestions;

                const suggestionsToShow = uniqueMatches.length > 0 ? uniqueMatches : filteredDefaultSuggestions;

                recommendedProductsContainer.innerHTML = suggestionsToShow
                  .map(product => `<li><a href="${product.url}">${product.name}</a></li>`)
                  .join('');

                await handleArticleResults(articleData.results || [], query);
                await handleProductResults(shopifyProducts, productData.resources?.results?.pages || [], query);
                await handlePageResults(productData.resources?.results?.pages || [], shopifyProducts, query);

            } catch (error) {
                console.error('Search error:', error);
                handleError();
            }
        }

        // Search input handler
        if (searchInput) {
            let searchTimeout;
            searchInput.addEventListener('input', (e) => {
                const query = e.target.value.trim();

                if (query.length > 2) {
                    // Escribiendo "air", la "a" y la "i" pasan por la rama de
                    // abajo y programan un cierre a 200ms cada una. Sin este
                    // clearTimeout, esos dos cierres caen sobre el panel que
                    // acaba de abrir la "r" y el usuario no ve ningun
                    // resultado, salvo que escriba mas lento que 200ms por
                    // tecla.
                    clearTimeout(hideOverlayTimeout);
                    searchOverlay.style.display = 'block';
                    requestAnimationFrame(function () {
                        searchOverlay.classList.add('is-visible');
                    });
                    clearTimeout(searchTimeout);
                    searchTimeout = setTimeout(() => {
                        performSearch(query);
                    }, 300);
                } else {
                    // Al borrar hasta 2 caracteres o menos tambien hay que
                    // cancelar la busqueda pendiente, o llega tarde y repinta
                    // resultados sobre un panel que ya se esta cerrando.
                    clearTimeout(searchTimeout);
                    searchOverlay.classList.remove('is-visible');
                    clearTimeout(hideOverlayTimeout);
                    hideOverlayTimeout = setTimeout(function () {
                        searchOverlay.style.display = 'none';
                    }, 200);
                }
            });
        }

        let lastQuery = '';

        function handleArticleResults(articles, query) {
            const articlesWithImages = articles.filter(article => article.featuredImageUrl);
            const paginationElement = document.querySelector('.blog-pagination');
            const isMobile = window.innerWidth <= 1024;

            for (let i = 1; i <= 15; i++) {
                if (resultSlots[i]) {
                    resultSlots[i].innerHTML = '';
                    resultSlots[i].style.display = 'block';
                }
            }

            if (articlesWithImages.length === 0) {
                paginationElement.style.display = 'none';
                if (resultSlots[1]) {
                    resultSlots[1].innerHTML = `
                        <div class="no-results-message">No articles found for "${query}"</div>
                    `;
                }
                return;
            }

            if (isMobile) {
                paginationElement.style.display = 'none';

                for (let i = 0; i < Math.min(10, articlesWithImages.length); i++) {
                    if (resultSlots[i + 1]) {
                        resultSlots[i + 1].innerHTML = generateArticleHTML(articlesWithImages[i]);
                    }
                }

                for (let i = articlesWithImages.length + 1; i <= 15; i++) {
                    if (resultSlots[i]) {
                        resultSlots[i].style.display = 'none';
                    }
                }
            } else {
                paginationElement.style.display = 'flex';
                for (let i = 0; i < Math.min(3, articlesWithImages.length); i++) {
                    if (resultSlots[i + 1]) {
                        resultSlots[i + 1].innerHTML = generateArticleHTML(articlesWithImages[i]);
                    }
                }
                for (let i = 4; i <= 15; i++) {
                    if (resultSlots[i]) {
                        resultSlots[i].style.display = 'none';
                    }
                }
            }
        }

        function handleProductResults(products, pages, query) {

            const blacklistedProducts = ['currency-base'];

            const filteredProducts = products.filter(product =>
              !blacklistedProducts.some(blacklisted =>
                product.handle?.toLowerCase().includes(blacklisted.toLowerCase())
              )
            );

            if (filteredProducts.length > 0) {
                const productsHTML = filteredProducts.map(product => {
                    const html = generateProductHTML(product);
                    return html;
                }).join('');

                resultsContainer.innerHTML = productsHTML;
            }
        }
        window.additionalPages = [];
        function handlePageResults(pages, products, query) {

            const keywordPageMapping = {
                'airbend-schools': {
                    keywords: [
                        'smart hvac schools', 'energy-efficient university hvac', 'classroom climate control',
                        'school hvac automation', 'hvac savings education', 'sustainable school cooling',
                        'iot hvac schools', 'air quality classrooms', 'campus hvac management',
                        'smart thermostats schools'
                    ],
                    page: {
                        url: '/pages/airbend-schools',
                        title: 'Sensibo Airbend For Educational Institutions',
                        body: 'Smart HVAC solution for schools and educational institutions'
                    }
                },
                'airbend-hotels': {
                    keywords: [
                        'smart hvac hotels', 'energy-saving airbnb hvac', 'resort climate control',
                        'hospitality hvac automation', 'hotel ac cost reduction', 'iot hvac rentals',
                        'guest comfort hvac', 'sustainable hotel cooling', 'remote hvac hotels',
                        'smart thermostats hospitality'
                    ],
                    page: {
                        url: '/pages/airbend-hotels',
                        title: 'Sensibo Airbend For Hospitalities',
                        body: 'Smart HVAC solution for hotels and hospitality'
                    }
                },
                'airbend': {
                    keywords: [
                        'smart hvac offices', 'commercial hvac automation', 'office energy management',
                        'remote hvac monitoring', 'smart thermostats offices', 'business hvac optimization',
                        'air quality management offices', 'iot hvac workspaces', 'demand-based cooling',
                        'smart building hvac', 'airbend'
                    ],
                    page: {
                        url: '/pages/airbend',
                        title: 'Sensibo Airbend For Facilities and Offices',
                        body: 'Smart HVAC solution for commercial facilities and offices'
                    }
                },
                'sensibo-for-integrators': {
                    keywords: [
                        'smart hvac facility management', 'bms hvac integration', 'hvac automation',
                        'iot hvac property management', 'building energy hvac', 'remote hvac facility',
                        'hvac maintenance', 'multi site hvac solutions', 'hvac monitoring'
                    ],
                    page: {
                        url: '/pages/sensibo-for-integrators-and-facility-management',
                        title: 'Sensibo Airbend For Integrators and Facility Management',
                        body: 'Smart HVAC solution for facility managers and integrators'
                    }
                },
                'sensibo-os': {
                    keywords: [
                        'smart hvac oem', 'iot hvac manufacturing', 'ai-powered hvac systems',
                        'energy-efficient hvac parts', 'remote hvac diagnostics', 'industrial hvac iot',
                        'predictive hvac maintenance', 'hvac automation components', 'hvac b2b solutions',
                        'hvac hardware integration'
                    ],
                    page: {
                        url: '/pages/sensibo-os-for-brands',
                        title: 'Sensibo OS',
                        body: 'Operating system for HVAC manufacturers and brands'
                    }
                }
            };

            const queryLower = query.toLowerCase();
            window.additionalPages = [];

            Object.values(keywordPageMapping).forEach(mapping => {
                const hasMatchingKeyword = mapping.keywords.some(keyword =>
                  queryLower.includes(keyword.toLowerCase()) ||
                  keyword.toLowerCase().includes(queryLower)
                );

                if (hasMatchingKeyword) {
                    window.additionalPages.push(mapping.page);
                }
            });


            if (window.additionalPages.length > 0) {
                resultsContainer.innerHTML += window.additionalPages.map(generatePageHTML).join('');
            }
            const pageResults = document.querySelectorAll('.page-result').length;
            const productResults = document.querySelectorAll('.search-result-item').length;

            if (pageResults === 0 && productResults === 0) {
                resultsContainer.innerHTML = '<div class="no-results">No results found</div>';
            }

            return window.additionalPages.length;
        }

        function handleError() {
            resultSlots[1].innerHTML = `
      <div class="error-message">Error loading search results</div>
    `;
            resultsContainer.innerHTML = '<div class="no-results">Error loading results</div>';
        }

        function generateArticleHTML(article) {
            return `
      <a href="${article.url}" class="blog-result-item">
        <div class="blog-result-content">
          ${article.featuredImageUrl
              ? `<img src="${article.featuredImageUrl}" alt="" class="blog-result-image" loading="lazy">`
              : ''
            }
          <div class="blog-result-text">
            <h3 class="blog-result-title">${article.title}</h3>
            <p class="blog-result-description">
              ${article.description
              ? article.description.slice(0, 200) + (article.description.length > 200 ? '...' : '')
              : ''
            }
            </p>
          </div>
        </div>
      </a>
    `;
        }

        function generateProductHTML(product) {


            const fourPointFiveStarProducts = [
                'sensibo-elements',
                'sensibo-children-bundle',
                'sensibo-pure'
            ];

            const starImage = fourPointFiveStarProducts.includes(product.handle)
              ? window.sensiboHeaderAssets.stars45
              : window.sensiboHeaderAssets.stars5;

            return `
        <a href="${product.url}" class="search-result-item">
          <div class="search-result-image">
            <img
              src="${product.featured_image?.url || window.sensiboHeaderAssets.productImage.replace('HANDLE', product.handle)}"
              alt="${product.title}"
              loading="lazy"
              onerror="this.style.display='none'"
            >
          </div>
          <div class="search-result-content">
            <div class="result-product-title">${product.title}</div>
            <img src="${starImage}" alt="Product Rating" class="product-rating-stars" loading="lazy">
            <div class="result-product-description">${product.body
              ? product.body.split('.')[0].trim()
              : ''
            }</div>
          </div>
        </a>
      `;
        }

        function generatePageHTML(page) {
            const pageImages = {
                '/pages/airbend-schools': "https://cdn.shopify.com/s/files/1/1669/6891/files/airbend-schools.jpg?v=1741178377",
                '/pages/airbend-hotels': "https://cdn.shopify.com/s/files/1/1669/6891/files/airbend-hotels.jpg?v=1741178377",
                '/pages/airbend': "https://cdn.shopify.com/s/files/1/1669/6891/files/airbend.webp?v=1741178377",
                '/pages/sensibo-for-integrators-and-facility-management': "https://cdn.shopify.com/s/files/1/1669/6891/files/sensibo-for-integrators.jpg?v=1741178377",
                '/pages/sensibo-os-for-brands': "https://cdn.shopify.com/s/files/1/1669/6891/files/sensibo-os.jpg?v=1741178376"
            };

            const defaultImage = "https://cdn.shopify.com/s/files/1/1669/6891/files/airbend.webp?v=1741178377";

            return `
        <div class="page-result">
          <a href="${page.url}" class="page-result-link">
            <img
              src="${pageImages[page.url] || defaultImage}"
              alt="${page.title}"
              class="page-result-image"
              loading="lazy"
              onerror="this.style.display='none'"
            >
            <h3 class="page-result-title">${page.title}</h3>
            <p class="page-result-description">${page.body}</p>
          </a>
        </div>
      `;
        }

        // Pagination handler from third script
        const paginationContainer = document.querySelector('.blog-pagination');
        if (paginationContainer) {
            paginationContainer.addEventListener('click', async function (e) {
                if (e.target.id === 'prev-page' && window.currentPage > 1) {
                    window.currentPage--;
                    await searchInput.dispatchEvent(new Event('input'));
                }

                if (e.target.id === 'next-page') {
                    window.currentPage++;
                    await searchInput.dispatchEvent(new Event('input'));
                }
            });
        }

        if (resultsContainer) {
            resultsContainer.addEventListener('click', (e) => {
                // Check if the clicked element is a link or is inside a link
                const clickedLink = e.target.closest('a');
                if (clickedLink) {
                    // Immediately hide the search overlay
                    if (searchOverlay) {
                        searchOverlay.style.display = 'none';
                    }
                    if (searchExpanded) {
                        searchExpanded.style.display = 'none';
                    }
                    // Clear the search input
                    if (searchInput) {
                        searchInput.value = '';
                    }
                    // Also clear mobile search if it exists
                    const mobileSearchInput = document.querySelector('.mobile-search__input');
                    if (mobileSearchInput) {
                        mobileSearchInput.value = '';
                    }
                }
            });
        }

        if (blogResultsContainer) {
            blogResultsContainer.addEventListener('click', (e) => {
                const clickedLink = e.target.closest('a');
                if (clickedLink) {
                    if (searchOverlay) {
                        searchOverlay.style.display = 'none';
                    }
                    if (searchExpanded) {
                        searchExpanded.style.display = 'none';
                    }
                    if (searchInput) {
                        searchInput.value = '';
                    }
                    const mobileSearchInput = document.querySelector('.mobile-search__input');
                    if (mobileSearchInput) {
                        mobileSearchInput.value = '';
                    }
                }
            });
        }

        if (recommendedProductsContainer) {
            recommendedProductsContainer.addEventListener('click', (e) => {
                const clickedLink = e.target.closest('a');
                if (clickedLink) {
                    if (searchOverlay) {
                        searchOverlay.style.display = 'none';
                    }
                    if (searchExpanded) {
                        searchExpanded.style.display = 'none';
                    }
                    if (searchInput) {
                        searchInput.value = '';
                    }
                    const mobileSearchInput = document.querySelector('.mobile-search__input');
                    if (mobileSearchInput) {
                        mobileSearchInput.value = '';
                    }
                }
            });
        }
    });

    const categories = {
        acControl: {
            priority: 1,
            keywords: ['air conditioner', 'ac control', 'smart ac', 'remote ac', 'remote control', 'wifi control',
                'heat pump', 'heat pump controller', 'heat pump smart control', 'controller', 'phone',
                'climate control', 'hvac', 'smart thermostat', 'application', 'app', 'temperature', 'humidity'],
            product: {
                name: 'Sensibo Air Pro',
                url: '/products/sensibo-air-pro'
            }
        },
        airQuality: {
            priority: 2,
            keywords: ['air quality', 'iaq', 'co₂', 'indoor air quality', 'voc', 'pm2.5', 'pm10',
                'air pollution', 'humidity sensor', 'tvoc', 'air monitoring', 'air measurement', 'smart air quality'],
            product: {
                name: 'Sensibo Elements',
                url: '/products/sensibo-elements'
            }
        },
        airPurification: {
            priority: 2,
            keywords: ['air purifier', 'hepa', 'air filtration', 'clean air', 'filter',
                'dust', 'pollen', 'allergens', 'pet dander', 'improve air quality', 'air sanitizer'],
            product: {
                name: 'Sensibo Pure',
                url: '/products/sensibo-pure'
            }
        },
        smartSensors: {
            priority: 3,
            keywords: ['smart sensor', 'motion sensor', 'temperature sensor', 'door sensor', 'window sensor',
                'open/close sensor', 'occupancy sensor', 'presence detection', 'humidity sensor'],
            product: {
                name: 'Sensibo Smart Door/Window Sensor',
                url: '/products/door-sensor'
            }
        },
        hotels: {
            priority: 4,
            keywords: ['hotel', 'hospitality', 'guest experience', 'room automation',
                'energy management hotel', 'hotel smart control', 'hvac hotel', 'air conditioning hotel'],
            product: {
                name: 'Sensibo Airbend for Hotels',
                url: '/pages/airbend-hotels'
            }
        },
        education: {
            priority: 4,
            keywords: ['school', 'classroom air quality', 'educational facilities',
                'student air quality', 'energy savings schools', 'smart hvac schools', 'classroom climate control'],
            product: {
                name: 'Sensibo Airbend for Schools',
                url: '/pages/airbend-schools'
            }
        },
        commercialBuildings: {
            priority: 4,
            keywords: ['office', 'workspace', 'commercial building', 'facility management',
                'smart hvac system', 'building automation', 'energy efficiency',
                'enterprise hvac', 'business climate control'],
            product: {
                name: 'Sensibo Airbend',
                url: '/pages/airbend'
            }
        },
        manufacturers: {
            priority: 5,
            keywords: ['oem', 'white label', 'manufacturer', 'b2b solutions',
                'os', 'embedded software', 'hvac software', 'firmware',
                'api integration', 'iot hvac', 'custom hvac solution'],
            product: {
                name: 'Sensibo OS',
                url: '/pages/sensibo-os-for-brands'
            }
        },
        children: {
            priority: 3,
            keywords: ['baby', 'toddler', 'newborn', 'infant', 'kids', 'children',
                'nursery', 'baby room', 'asthma', 'allergies',
                'child', 'safe air', 'protect baby'],
            product: {
                name: 'Sensibo Healthy Children Bundle',
                url: '/products/healthy-children-bundle'
            }
        },
        airbnb: {
            priority: 4,
            keywords: ['airbnb', 'short-term rental', 'vacation rental', 'guest control',
                'host', 'property manager', 'smart hosting', 'smart thermostat rental',
                'rental automation', 'energy savings airbnb', 'airbnb smart home'],
            product: {
                name: 'Sensibo for Airbnb Hosts',
                url: '/products/airbnb-for-hosts'
            }
        },
        sustainability: {
            priority: 3,
            keywords: ['sustainability', 'carbon footprint', 'co₂ emissions', 'energy efficiency',
                'carbon reduction', 'net zero', 'climate impact', 'esg',
                'decarbonization', 'co₂ monitoring', 'energy savings', 'green tech',
                'eco-friendly', 'sustainable living', 'climate change mitigation',
                'carbon offset', 'green innovation', 'smart energy'],
            product: {
                name: 'Sensibo Impact',
                url: '/pages/our-impact'
            }
        }
    };

    const defaultSuggestions = [
        { name: 'Sensibo Air Pro', url: '/products/sensibo-air-pro' },
        { name: 'Sensibo Elements', url: '/products/sensibo-elements' },
        { name: 'Sensibo Pure', url: '/products/sensibo-pure' },
        { name: 'Sensibo Airbend', url: '/pages/airbend' }
    ];

    // Keep utility functions outside DOMContentLoaded
    function updateSuggestions(query) {
        query = query.toLowerCase();
        let matches = [];
        let categoryMatches = new Map();

        Object.entries(categories).forEach(([categoryKey, category]) => {
            let categoryScore = 0;
            let matchedKeywords = new Set();

            category.keywords.forEach(keyword => {
                if (keyword.toLowerCase().includes(query) || query.includes(keyword.toLowerCase())) {
                    matchedKeywords.add(keyword);
                    categoryScore += 1;
                }
            });

            if (categoryScore > 0) {
                categoryMatches.set(categoryKey, {
                    score: categoryScore * (1 / category.priority),
                    matchCount: matchedKeywords.size
                });

                if (category.products) {
                    category.products.forEach(product => {
                        matches.push({
                            name: product.name,
                            url: product.url,
                            score: categoryScore * (1 / category.priority),
                            categoryKey: categoryKey
                        });
                    });
                } else if (category.product) {
                    matches.push({
                        name: category.product.name,
                        url: category.product.url,
                        score: categoryScore * (1 / category.priority),
                        categoryKey: categoryKey
                    });
                }
            }
        });

        matches.sort((a, b) => {
            if (b.score !== a.score) {
                return b.score - a.score;
            }
            const categoryA = categories[a.categoryKey];
            const categoryB = categories[b.categoryKey];
            return categoryA.priority - categoryB.priority;
        });

        const seen = new Set();
        const uniqueMatches = matches.filter(item => {
            const duplicate = seen.has(item.name);
            seen.add(item.name);
            return !duplicate;
        });

        const results = uniqueMatches.length > 0
          ? uniqueMatches.slice(0, 4)
          : defaultSuggestions;

        recommendedProductsContainer.innerHTML = results
          .map(product => `<li><a href="${product.url}">${product.name}</a></li>`)
          .join('');
    }
